import Header from './Headers';
import Const from '../util/Constants';
import Config from '../config/config';

class TargetAPI {

  static list = (success, failure) => {
    fetch(Config.app.link + 'api/target', new Header('GET'))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }

  static get = (id, success, failure) => {
    fetch(Config.app.link + 'api/target/' + id, new Header('GET'))
    .then(result => result.json().then(async res => {
      try { res.design = JSON.parse(res.txt_body_json) } catch(er) { console.log(er) }
      success(res);
    })).catch(er => failure(er));
  }

  static save = (target, success, failure) => {
    fetch(Config.app.link + 'api/target/add-edit', new Header('POST', target))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }  

  static delete = (id, success, failure) => {
    fetch(Config.app.link + 'api/target/delete/' + id, new Header('GET'))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }

  static getLog = (id, success, failure) => {
    fetch(Config.app.link + 'api/target/log/' + id, new Header('GET'))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }
}
export default TargetAPI;